import { Store } from '@tanstack/react-store'

const initialState = {
  user: null,
  isAuthenticated: false,
}

export const authStore = new Store(initialState)

export const resetAuthStore = () => {
  authStore.setState({
    ...initialState,
  })
}
